/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueInstant from 'vue-instant';

import './plugins/vuex';
import './plugins/axios';
import { i18n } from './plugins/vue-i18n';
import { router } from './plugins/vue-router';
import './plugins/vuex-router-sync';
import './plugins/bootstrap';
import './plugins/font-awesome';
import './plugins/vue-instant';
import './plugins/flatpickr';
import './assets/stylus/app.styl';
import App from './App';
import store from './store';

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */

/* ============
 * Styling
 * ============
 *
 * Import the application styling.
 * Stylus is used for this boilerplate.
 *
 * If you don't want to use Stylus, that's fine!
 * Replace the stylus directory with the CSS preprocessor you want.
 * Import the entry point here & install the webpack loader.
 *
 * It's that easy...
 *
 * http://stylus-lang.com/
 */

/* ============
 * Main App
 * ============
 *
 * Last but not least, we import the main application.
 */

Vue.config.productionTip = false;

store.dispatch('auth/check');

Vue.use(BootstrapVue);
Vue.use(VueInstant);

/* eslint-disable no-new */
new Vue({
    /**
     * Bind the Vue instance to the HTML.
     */
    el: '#app',

    /**
     * The localization plugin.
     */
    i18n,

    /**
     * The router.
     */
    router,

    /**
     * The Vuex store.
     */
    store,

    /**
     * Will render the application.
     *
     * @param {Function} h Will create an element.
     */
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js